

import { Aplicativo } from './aplicativo';


export class Menu {

	idMenu: string;

	nombre: string;

	descripcion: string;

	ruta: string = '';

	estaActivo: boolean = false;

	icono: string = '';

	requiereUnidad: boolean = false;

	nodoHoja: boolean = false;

	orden: number = 1;

	menuPadre: Menu;

	aplicativo: Aplicativo;

	hijos: Menu[] = [];


	static clonar(objectToCopy: Menu): Menu{
		return (JSON.parse(JSON.stringify(objectToCopy)));
	}
	
	clonando(): Menu{
		return (JSON.parse(JSON.stringify(this)));
	}

}
